// Section8MicrofinanceRegistration.jsx
import React from "react";

export default function Section8MicrofinanceRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Section 8 Microfinance Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Section 8 Microfinance Company Registration
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in Section 8 Microfinance Company
            Registration, enabling compliant micro-lending operations for social
            objectives serving financially excluded communities.
          </p>
          <p className="text-gray-700">
            From RBI NBFC-MFI compliance alignment within Section 8 structure to
            MCA license approval, JLG operational framework, and social impact
            reporting systems, the process ensures sustainable microfinance
            delivery with corporate governance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Microfinance group lending) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/6646909/pexels-photo-6646909.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Microfinance group lending meeting for Section 8 company"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Section 8 Microfinance Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks structures Section 8 documentation with RBI
              microfinance compliance integration for MCA approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Incorporation documents including MOA/AOA with microfinance social objectives.</li>
                <li>
                  Director identity proof (PAN, Aadhaar, passport) and financial
                  eligibility declarations for lending operations.
                </li>
                <li>
                  Financial and operational details covering JLG framework,
                  lending model, borrower selection criteria, and social impact
                  metrics.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm combines Section 8 non-profit expertise with RBI
              microfinance compliance for sustainable social lending enterprises.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Microfinance Regulations
                </h3>
                <p className="text-gray-700 text-sm">
                  Specialized knowledge of RBI NBFC-MFI guidelines within
                  Section 8 structure, JLG lending compliance, pricing
                  regulations, and social performance management standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Systematic MCA Section 8 license process with RBI-aligned
                  MOA/AOA, operational frameworks, governance structures, and
                  statutory compliance declarations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from entity structuring and SPICe+ filing
                  through RBI compliance readiness, MIS reporting systems, and
                  sustainable microfinance operations advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
